export const userAttributes = (membership: string, gender: string, ageRange: string, classTicketName: string) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'user_property',
        'user_membership': membership,  // value range: suite, delux, standard
        'user_gender': gender,  // value range: male, female
        'user_age_range': ageRange,  // value range: 18-24, 25-34, 35-44, 45-54, 55-64
        'class_ticket_name': classTicketName  // 유효 정기권만 표시, 없으면 하이픈(-)처리
    });
}

export const selectProgram = (title: string, state: string) => {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
        'event': 'select_program',
        'program_name': title,  // 프로그램 이름
        'program_state': state  // value range: 오픈예정, 예약가능, 예약마감, 종료
    });
}

export const viewProgram = (title: string, scrollRange: "0%" | "25%" | "50%" | "75%" | "100%") => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'view_program',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'program_scroll': scrollRange,  // value range: 25%, 50%, 75%, 100%
    });

}

export const shareProgram = (title: string, isPaid: "유료" | "무료", type: "온라인" | "오프라인") => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'share_program',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'is_paid': isPaid,  // 유/무료 여부
        'type': type  // 오프라인/온라인 구분
    });


}

export const selectProgramRequest = (title: string, isPaid: "유료" | "무료", type: "온라인" | "오프라인") => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'select_program_request',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'is_paid': isPaid,  // 유/무료 여부
        'type': type  // 오프라인/온라인 구분
    });
}

export const selectProgramQuantity = (title: string, ticketName: string, quantity: number, price: number) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'select_program_quantity',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'ticket_name': ticketName,  // 티켓 여러개일 경우 쉼표(,)로 구분, 무료는 하이픈(-)으로 표기
        'quantity': quantity,  // 인원, 유료 티켓 여러개일 경우 전체 인원 합으로 표기
        'price': price  // 가격, 무료는 '0'으로 표기
    });
}

export const finishedSelectProgramBasic = (title: string, ticketName: string, quantity: number, price: number, date: string, time: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'finished_select_program_basic',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'ticket_name': ticketName,  // 티켓 여러개일 경우 쉼표(,)로 구분, 무료는 하이픈(-)으로 표기
        'quantity': quantity,  // 인원, 유료 티켓 여러개일 경우 전체 인원 합으로 표기
        'price': price,  // 가격, 무료는 '0'으로 표기
        'date': date,  // 선택한 날짜 표기
        'time': time  // 선택한 시간 표기
    });
}

export const confirmedRequestDetail = (title: string, ticketName: string, quantity: number, price: number, date: string, time: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'confirmed_request_detail',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'ticket_name': ticketName,  // 티켓 여러개일 경우 쉼표(,)로 구분, 무료는 하이픈(-)으로 표기
        'quantity': quantity,  // 인원, 유료 티켓 여러개일 경우 전체 인원 합으로 표기
        'price': price,  // 가격, 무료는 '0'으로 표기
        'date': date,  // 선택한 날짜 표기
        'time': time  // 선택한 시간 표기
    });
}

export const finishedProgramRequest = (title: string, ticketName: string, quantity: number, price: number, date: string, time: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'finished_program_request',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'ticket_name': ticketName,  // 티켓 여러개일 경우 쉼표(,)로 구분, 무료는 하이픈(-)으로 표기
        'quantity': quantity,  // 인원, 유료 티켓 여러개일 경우 전체 인원 합으로 표기
        'price': price,  // 가격, 무료는 '0'으로 표기
        'date': date,  // 선택한 날짜 표기
        'time': time  // 선택한 시간 표기
    });
}

export const paidProgram = (title: string, isPaid: "유료" | "무료", type: "온라인" | "오프라인", ticketName: string, quantity: number, price: number, couponName: string, discount: number, finalPrice: number) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'paid_program',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'is_paid': isPaid,  // 유/무료 여부
        'type': type,  // 오프라인/온라인 구분
        'ticket_name': ticketName,  // 티켓 여러개일 경우 쉼표(,)로 구분, 무료는 하이픈(-)으로 표기
        'quantity': quantity,  // 인원, 유료 티켓 여러개일 경우 전체 인원 합으로 표기
        'price': price,  // 가격, 무료는 '0'으로 표기
        'coupon_name': couponName,  // 쿠폰 이름
        'discount': discount,  // 할인된 금액
        'final_price': finalPrice  // 실결제금액
    });
}

export const cancelProgram = (title: string, reserveState: "예약대기" | "결제대기" | "예약확정", isPaid: "유료" | "무료", type: "온라인" | "오프라인", ticketName: string, quantity: number, price: number, date: string, time: string, requestDate: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'cancel_program',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'reserve_state': reserveState,  // value range: 예약대기, 결제대기, 예약확정
        'is_paid': isPaid,  // 유/무료 여부
        'type': type,  // 오프라인/온라인 구분
        'ticket_name': ticketName,  // 티켓 여러개일 경우 쉼표(,)로 구분, 무료는 하이픈(-)으로 표기
        'quantity': quantity,  // 인원, 유료 티켓 여러개일 경우 전체 인원 합으로 표기
        'price': price, // 가격, 무료는 '0'으로 표기
        'date': date,  // 선택한 날짜 표기
        'time': time,  // 선택한 시간 표기
        'request_date': requestDate  // 예약신청일 표기
    });
}

export const requestCancelProgram = (title: string, type: "온라인" | "오프라인", ticketName: string, quantity: number, price: number, date: string, time: string, requestDate: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'request_cancel_program',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'type': type,  // 오프라인/온라인 구분
        'ticket_name': ticketName,  // 티켓 여러개일 경우 쉼표(,)로 구분, 무료는 하이픈(-)으로 표기
        'quantity': quantity,  // 인원, 유료 티켓 여러개일 경우 전체 인원 합으로 표기
        'price': price,  // 가격, 무료는 '0'으로 표기
        'date': date,  // 선택한 날짜 표기
        'time': time,  // 선택한 시간 표기
        'request_date': requestDate  // 예약신청일 표기
    });
}

export const restoreCancelProgram = (title: string, type: "온라인" | "오프라인", ticketName: string, quantity: number, price: number, date: string, time: string, requestDate: string, requestCancelDate: string) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        'event': 'restore_cancel_program',  // 이벤트 이름
        'program_name': title,  // 프로그램 이름
        'type': type,  // 오프라인/온라인 구분
        'ticket_name': ticketName,  // 티켓 여러개일 경우 쉼표(,)로 구분, 무료는 하이픈(-)으로 표기
        'quantity': quantity,  // 인원, 유료 티켓 여러개일 경우 전체 인원 합으로 표기
        'price': price,  // 가격, 무료는 '0'으로 표기
        'date': date,  // 선택한 날짜 표기
        'time': time,  // 선택한 시간 표기
        'request_date': requestDate,  // 예약신청일 표기
        'request_cancel_date': requestCancelDate// 취소 요청일 표기
    });
}
